// extracted by mini-css-extract-plugin
export default {"commentsSection":"Comments_commentsSection__lLnFv","commentsTitle":"Comments_commentsTitle__LjQi3","comments":"Comments_comments__kE+lr"};